import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { sessionActionCreators } from '../../stores/lis-session-store';
import { navActionCreators } from '../../stores/lis-nav-store';
import { communicationsActionCreators } from '../../stores/lis-communications-store';
import moment from 'moment-timezone';

import { cancelRequest } from '../../services/request.service';
import { Link } from 'react-router-dom';

class PublicCommunicationsList extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            session: '',
            senateIsLoaded: false,
            houseIsLoaded: false,
            senateCommList: [],
            houseCommList: [],
            showHouseChamber: true,
            showSenateChamber: true,
            selectedChamber: "H"
        };
        this.toggleChamber = this.toggleChamber.bind(this);
        this.toggleSelectedChamber = this.toggleSelectedChamber.bind(this);
    }

    toggleChamber(chamber) {
        this.setState(state => ({
            [chamber]: !state[chamber]
        }));
    }

    //When component has mounted, make the call to get session by code
    componentDidMount() {
        const sessionCode = this.props.match.params.sessioncode
        if (parseInt(sessionCode) > 0) {
            //Update the session selector component, which will run componentDidUpdate and call setupPage on its own
            if (this.props.nav.session !== sessionCode) {
                this.props.actions.changeSession(sessionCode)
            } else {
                this.setupPage(sessionCode);
            }
        }
    }

    componentDidUpdate(prevProps) {
        // Setup the page if the global selected session changes. Change the URL to reflect the session change
        if (prevProps.nav.session !== this.props.nav.session) {
            this.props.history.push("/session-details/" + this.props.nav.session + "/communications");
            this.setupPage(this.props.nav.session);
        } else if (this.props.nav.session !== this.props.match.params.sessioncode) {
            // If the url changes then update the global selected session with whatever the url is
            const sessionCode = this.props.match.params.sessioncode;
            if (!isNaN(sessionCode)) {
                this.props.actions.changeSession(sessionCode);
            }
        }
    }

    componentWillUnmount() {
        cancelRequest();
    }

    setupPage(sessionCode) {
        this.setState({
            senateIsLoaded: false,
            houseIsLoaded: false
        });
        const createCommList = commList => {
            commList.forEach(comm => {
                const jsonFile = comm.CommunicationFiles.find(file => file.FileURL.includes('JSON'))
                if (jsonFile && jsonFile.IsGenerated) {
                    comm.jsonFile = jsonFile
                }
            });
            return commList;
        }
        //Get the session information
        this.props.actions.getSessionByCode(sessionCode)
            .then(() => {
                this.setState({
                    session: this.props.session.selectedSession,
                });
            });
        //Get the list for the Senate
        this.props.actions.getCommList('?sessionCode=' + sessionCode + '&chamberCode=S&communicationType=Floor')
            .then(() => {
                this.setState({
                    senateCommList: createCommList([...this.props.communications.commList]),
                    senateIsLoaded: true
                });
            });
        //Get the list for the House
        this.props.actions.getCommList('?sessionCode=' + sessionCode + '&chamberCode=H&communicationType=Floor')
            .then(() => {
                this.setState({
                    houseCommList: createCommList([...this.props.communications.commList]),
                    houseIsLoaded: true
                });
            });
    }

    toggleSelectedChamber() {
        this.setState({
            selectedChamber: this.state.selectedChamber === "H" ? "S" : "H"
        })
    }

    render() {
        const { senateCommList, houseCommList, senateIsLoaded, houseIsLoaded, session } = this.state;
        const sessionHeader = session ? session.SessionYear + " " + session.DisplayName : '';
        return (
            <div className="public-chamber-data communication-list">
                <div>
                    <h2 style={{paddingTop: "5px"}}>Communications</h2>
                    {window.innerWidth <= 500 &&
                        <div className='toggle-tabs'>
                            <div className={'toggle-tab ' + (this.state.selectedChamber === "H" ? "active" : "")}>
                                <label onClick={() => this.toggleSelectedChamber()}>House</label>
                            </div>
                            <div className={'toggle-tab ' + (this.state.selectedChamber === "S" ? "active" : "")}>
                                <label onClick={() => this.toggleSelectedChamber()}>Senate</label>
                            </div>
                        </div>
                    }
                </div>
                <div className={"public-list " + (window.innerWidth > 500 ? "inner-grid two" : "")}>
                    <div>
                        {window.innerWidth > 500 &&
                            <h3 style={{marginTop: "15px"}}>House</h3>
                        }
                        {(houseIsLoaded && this.state.showHouseChamber && window.innerWidth > 500) || (window.innerWidth <= 500 && this.state.selectedChamber === "H") ?
                            <table className="line-table">
                                <tbody className="toggle-table">
                                    <div className="list-desc">
                                        {houseCommList.map(comm =>
                                            <tr key={comm.CommunicationID} className="inner-grid two communication-row">
                                                <td>
                                                    <Link to={`/session-details/${this.state.session.SessionCode}/communications/${comm.ReferenceNumber}`}>
                                                        {moment(comm.CommunicationDate).tz('America/New_York').format("dddd, MMMM D, YYYY")} {comm.CommunicationNumber > 1 && `(${comm.CommunicationNumber})`}
                                                    </Link>
                                                </td>
                                            </tr>
                                        )}
                                    </div>
                                </tbody>
                            </table>
                            :
                            !houseIsLoaded && <div className="center-spinner spinner"></div>
                        }
                    </div>
                    <div>
                        {window.innerWidth > 500 &&
                            <h3 style={{marginTop: "15px"}}>Senate</h3>
                        }
                        {(senateIsLoaded && this.state.showSenateChamber && window.innerWidth > 500) || (window.innerWidth <= 500 && this.state.selectedChamber === "S") ?
                            <table className="line-table">
                                <tbody className="toggle-table">
                                    <div className="list-desc">
                                        {senateCommList.map(comm =>
                                            <tr key={comm.CommunicationID} className="inner-grid two communication-row">
                                                <td>
                                                    <Link to={`/session-details/${this.state.session.SessionCode}/communications/${comm.ReferenceNumber}`}>
                                                        {moment(comm.CommunicationDate).tz('America/New_York').format("dddd, MMMM D, YYYY")} {comm.CommunicationNumber > 1 && `(${comm.CommunicationNumber})`}
                                                    </Link>
                                                </td>
                                            </tr>
                                        )}
                                    </div>
                                </tbody>
                            </table>
                            :
                            !senateIsLoaded && <div className="center-spinner spinner"></div>
                        }
                    </div>
                </div>
            </div >
        );
    }
}

export default connect(
    (state) => {
        const { session, nav, communications } = state;
        return {
            session,
            nav,
            communications
        }
    },
    (dispatch) => {
        return {
            actions: bindActionCreators(Object.assign({}, sessionActionCreators, navActionCreators, communicationsActionCreators), dispatch)
        }
    }
)(PublicCommunicationsList)
